import script from "./Sp2Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Sp2Header.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__